import {
  NOTIFICATIONS_FETCH_SUCCEEDED,
  NOTIFICATIONS_FETCH_FAILED,
  NOTIFICATIONS_READ_SUCCEEDED,
  NOTIFICATIONS_READ_FAILED,
} from "./reducer";

import { fetchNotifications, notificationsRead } from "../../utils/api";

export async function notificationsRequest(dispatch: any) {
  try {
    let response = await fetchNotifications();
    let data = await response.json();

    if (data.status == "success") {
      const notifications = data.notifications || [];
      const new_notifications_count = data.new_notifications_count || 0;
      dispatch({
        type: NOTIFICATIONS_FETCH_SUCCEEDED,
        payload: { notifications, new_notifications_count },
      });
    } else {
      dispatch({ type: NOTIFICATIONS_FETCH_FAILED });
    }
  } catch (error) {
    dispatch({ type: NOTIFICATIONS_FETCH_FAILED });
  }
}

export async function notificationsViewed(dispatch: any) {
  try {
    let response = await notificationsRead();
    let data = await response.json();

    if (data.status == "success") {
      dispatch({ type: NOTIFICATIONS_READ_SUCCEEDED });
    } else {
      dispatch({ type: NOTIFICATIONS_READ_FAILED });
    }
  } catch (error) {
    dispatch({ type: NOTIFICATIONS_READ_FAILED });
  }
}
